module.exports = "https://cdn.realtymogul.com/static/media/chart_investing_in_reits.18d6aade.png";